import React, { useState } from 'react';
import { addDDLCollection } from '../utils/storage';
import { ModalTemplate } from './templates';

export default function CreateCategoryModal({ onClose, onCreated }) {
  const [name, setName] = useState('ddl_');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    try {
      await addDDLCollection(name);
      onCreated();
    } catch (err) {
      console.error('Failed to create collection:', err);
      setSaving(false);
    }
  }

  return (
    <ModalTemplate title="New Collection" onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Collection Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. ddl_objectType, ddl_coatingMaterial..."
            autoFocus
          />
        </div>

        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!name.trim() || saving}
          >
            {saving ? 'Creating...' : 'Create'}
          </button>
        </div>
      </form>
    </ModalTemplate>
  );
}
